// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2024-09-19 11:56:06 +0200 (Thu, 19 Sep 2024) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 145927 $
//  Purpose   : setup persist (localStorage, sessionStorage)
//              for the appropriate env (browser, ssr, electron)
//
//  see https://web.dev/storage-for-the-web/#other
//
// =============================================================================
// ---Third-party imports
import createIdbStorage from '@piotr-cz/redux-persist-idb-storage'
import {createMigrate, persistReducer as _persistReducer} from 'redux-persist'

// ---Framework imports
import log from 'uix/logging'
import {isString} from 'ldash'

// ---Local imports
import {getStoreNames} from './utils'

// ---Globals

//~ let persistVersioning = () => {
//~ let migrate = createMigrate(
//~ {
//~ [version - 1]: state => ({}),
//~ },
//~ {debug: false}
//~ )

//~ return {migrate}
//~ }

const writeFailHandler = key => root => log.exception('persist failed for key %o', key)
// by handling persist/REHYDRATE
export const readFailHandler = key =>
  log.exception(
    'persist load failed for key %o (this happens on https://github.com/rt2zz/redux-persist/issues/1081)',
    key
  )

export let persistReducer = (reducer, options) => {
  // persist data of given reducer
  let persistStorage = null
  if (isString(options)) {
    options = {key: options}
  }
  let {key} = options

  // some sanity checks
  if (!isString(key) || key.length == 0) {
    log.error('invalid or empty persistence key for %o', options)
  }

  if (process.env.UIX_ENV == 'express') {
    // no persistence
    return reducer
  } else if (process.env.UIX_ENV == 'browser') {
    if (options.scope == 'session') {
      // limited to 5 MB
      persistStorage = require('redux-persist/lib/storage/session').default
    } else {
      let {dbName, storeName} = getStoreNames()
      // https://github.com/piotr-cz/redux-persist-idb-storage#setup
      persistStorage = createIdbStorage({name: dbName, storeName})
      // Data serialization is not required and disabling it allows you to inspect storage value in DevTools
      //~ options = {...options, serialize: false}
    }
  } else {
    throw Error(`unknown env ${process.env.UIX_ENV}`)
  }

  let persistConfig = {
    key,
    storage: persistStorage,
    writeFailHandler: writeFailHandler(key),
    ...options,
    //~ ...persistVersioning(),
  }
  return _persistReducer(persistConfig, reducer)
}
